import { parseISO, format } from 'date-fns';
import { enUS, de, es, fr, pt, ru, tr, zhCN, ja, cs, ko } from 'date-fns/locale';

const defaultLocale = 'en';
const shortFormat = 'd. MMM';
const locales = {
  en: { lang: enUS, format: 'd MMMM, yyyy' },
  de: { lang: de, format: 'dd.MM.yyyy' },
  es: { lang: es, format: 'dd/MM/yyyy' },
  fr: { lang: fr, format: 'dd/MM/yyyy' },
  pt: { lang: pt, format: 'dd/MM/yyyy' },
  ru: { lang: ru, format: 'd MMM yyyy' },
  tr: { lang: tr, format: 'dd.MM.yyyy' },
  cn: { lang: zhCN, format: 'yyyy-MM-dd' },
  jp: { lang: ja, format: 'yyyy/MM/dd' },
  cz: { lang: cs, format: 'dd.MM.yyyy' },
  ko: { lang: ko, format: 'yyyy MM dd' }
};

export class DateFormatter {
  static parse(value) {
    console.warn(
      '`DateFormatter.parse(value)` is deprecated. ' +
      'Use `dateUtils.parse(value)` instead. (ui-framework-utils)'
    );
    return (typeof value === 'string') ? parseISO(value) : value;
  }

  static format(date, options = {}) {
    console.warn(
      '`DateFormatter.format(date, { locale, short })` is deprecated. ' +
      'Use `dateUtils.formatByLocale(date, { locale, short })` instead. (ui-framework-utils)'
    );
    const locale = options.hasOwnProperty('locale') ? this._getValidLocale(options.locale) : defaultLocale;
    const dateFormat = options.hasOwnProperty('short') && options.short ? shortFormat : locales[locale].format;
    return format(date, dateFormat, {
      locale: locales[locale].lang
    });
  }

  static get locales() {
    console.warn('`DateFormatter.locales` is deprecated. Use `dateUtils.locales` instead. (ui-framework-utils)');
    return locales;
  }

  static _getValidLocale(locale) {
    return locales.hasOwnProperty(locale) ? locale : defaultLocale;
  }
}
